"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPropertiesI18nBundle = exports.getCapI18nBundle = void 0;
var cap_1 = require("./cap");
Object.defineProperty(exports, "getCapI18nBundle", { enumerable: true, get: function () { return cap_1.getCapI18nBundle; } });
var properties_1 = require("./properties");
Object.defineProperty(exports, "getPropertiesI18nBundle", { enumerable: true, get: function () { return properties_1.getPropertiesI18nBundle; } });
//# sourceMappingURL=index.js.map